/** Cooler families that can share one C3 graphic artwork set. */
export enum C3GraphicCompatibleModel {
    Pickup = 'Pickup',
    Rover = 'Rover',
    CoolerTrailer = 'Cooler Trailer',
    DeliveryTruck = 'Delivery Truck',
    Zamboni = 'Zamboni',
    Boat = 'Boat',
}
